import type { RuntimeConfig } from '@nuxt/schema'

export type ConfigAppType = any | RuntimeConfig

export type TCommon =
  | object
  | string
  | unknown
  | undefined
  | null
  | boolean
  | number
  | any

export type TRecord = Record<string, any>

export type TGeneral = {
  [key: string]: TCommon
}

export type TLoaderSize = 'small' | 'large' | 'xlarge'

export type TScripts = TScript[]

export type TScript = {
  src?: string
  rel?: string
  hid?: string
  id?: string
  type?: string
  async?: boolean;
  defer?: boolean
  fetchPriority?: string
  innerHTML?: string
}

export type TVimeoData = {
  title: string
  duration: number
}

export enum ResponseStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING = 'pending',
  IDLE = 'idle',
}
